export default __webpack_public_path__ + "4be4c458c7af99b130242f2ab40581e1.svg";